<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-fridge-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 24a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm0-14a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm6.238-8C39.211 2 40 2.658 40 3.47v37.06c0 .812-.789 1.47-1.762 1.47H36v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3H16v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3H9.762C8.789 42 8 41.342 8 40.53V3.47C8 2.659 8.789 2 9.762 2h28.476zM12 6v32h24V6H12zm0 13h24v4H12v-4z"/></svg>
</template>
<script>

export default {
  name: 'IconFridgeAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
